import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollSmoother from 'gsap/ScrollSmoother';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

export const smoother = () => {
    const scroller = ScrollSmoother.create({
                        smooth: 1.4,
                        effects: true,
                        smoothTouch: 0.3,
                        normalizeScroll: true
                    });
    document.querySelector('#smooth-content').style.transform = 'translate(0,0)';
    scroller.paused(true);
    return scroller;
}

export const normalizer = (val) => {
    ScrollTrigger.normalizeScroll(val);
}

export const smootherPause = (e) => {
    const scroller = ScrollSmoother.get();
    scroller.paused(e);
}
